import { DEFAULT_ERRORS } from '../constants';

export const MessageTypes = {
  ssoSuccess: 'ssoSuccess',
  ssoFail: 'ssoFail',
};

export const BROADCAST_CHANNEL_NAME = 'pollfish:sso';
export const OUTCOME_SUCCESS = 'success';
export const OUTCOME_FAIL = 'fail';

export const getSsoFailureMessage = (data = {}) => {
  const errorCode = data.errorData && data.errorData.errors && data.errorData.errors[0];
  if (errorCode && DEFAULT_ERRORS[errorCode]) {
    return DEFAULT_ERRORS[errorCode];
  }
  if (data.errorStatus === 503) {
    return DEFAULT_ERRORS.service_unavailable;
  }
  if (data.errorStatus >= 400 && data.errorStatus < 500) {
    return DEFAULT_ERRORS.POLLFISH_SSO_NOT_SUPPORTED;
  }
  return DEFAULT_ERRORS.SSO_FAIL;
};